import { TableColumn, TableRow } from '@/components/Table/types';
import i18next from 'i18next';
import { Trans } from 'react-i18next';

type CriticalityColumnConfig<T extends TableRow> = {
  options?: Omit<TableColumn<T>, 'id' | 'label'>;
};

export const criticalityColumnConfig = <T extends TableRow>({
  options,
}: CriticalityColumnConfig<T> = {}): TableColumn<T> => ({
  id: 'criticality',
  label: <Trans i18nKey="criticality" />,
  render: (value) => (
    <div className="overflow-hidden text-ellipsis">{i18next.t(value)}</div>
  ),
  acessorKey: 'priority',
  sortable: true,
  className: 'max-w-[20vw] w-[20vw]',
  ...options,
});
